import axios from "./axios.service";

export const createTicket = (data) => {
  return axios.post("/ticket", data).then((res) => res.data);
};
